import React from 'react';
import { MessageSquare, Palette, Eye, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const steps = [
  {
    number: 1,
    icon: <MessageSquare className="w-12 h-12" />,
    title: 'Vous me contactez',
    description: 'Dites-moi simplement ce que vous faites et ce dont vous avez besoin pour votre site.'
  },
  {
    number: 2,
    icon: <Palette className="w-12 h-12" />,
    title: 'Je crée une première ébauche',
    description: 'Je conçois votre site avec vos informations. Aucun paiement demandé à ce stade.'
  },
  {
    number: 3,
    icon: <Eye className="w-12 h-12" />,
    title: 'Vous recevez un aperçu gratuit',
    description: 'Je vous envoie le lien de votre ébauche. Vous pouvez la voir en ligne et la tester.'
  },
  {
    number: 4,
    icon: <CheckCircle className="w-12 h-12" />,
    title: 'Vous décidez',
    description: 'Si ça vous plaît, on finalise. Sinon, vous ne payez rien et on s\u2019arrête là.'
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-16 sm:py-20 bg-white w-full overflow-hidden">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1E3A5F] mb-4">
            Comment ça fonctionne ?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Un processus simple et transparent en 4 étapes
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-12">
          {steps.map((step) => (
            <Card
              key={step.number}
              className="relative hover:shadow-xl transition-all duration-300 border-2 hover:border-[#FF9933]/30 bg-white"
            >
              <CardContent className="p-6 text-center">
                {/* Step Number Badge */}
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[#FF9933] text-white flex items-center justify-center font-bold text-lg">
                  {step.number}
                </div>
                
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#FF9933]/10 text-[#FF9933] mb-4 mt-2">
                  {step.icon}
                </div>
                
                {/* Title */}
                <h3 className="text-xl font-bold text-[#1E3A5F] mb-3">
                  {step.title}
                </h3>
                
                {/* Description */}
                <p className="text-gray-600 leading-relaxed text-sm">
                  {step.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Info Box */}
        <div className="bg-blue-50 border-l-4 border-[#FF9933] p-6 rounded-lg max-w-4xl mx-auto">
          <p className="text-[#1E3A5F] text-base sm:text-lg">
            <span className="font-bold">💡 Aucun engagement</span> - Vous voyez exactement à quoi ressemble votre ébauche avant de décider quoi que ce soit
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
